const updates = [
  { time: '14:28', tag: '爆', tagColor: 'bg-primary-500', title: '某顶流男星疑似与神秘女子深夜同返公寓，粉丝炸锅', views: '12.3万' },
  { time: '13:15', tag: '新', tagColor: 'bg-accent-500', title: '热播剧女主被曝片场耍大牌，多位群演实名爆料', views: '9.8万' },
  { time: '11:42', tag: '热', tagColor: 'bg-primary-400', title: '知名综艺录制现场突发意外，节目组紧急回应中', views: '8.5万' },
  { time: '10:06', tag: '爆', tagColor: 'bg-primary-500', title: '某电商主播涉嫌虚假宣传被立案调查，平台已下架相关商品', views: '15.1万' },
  { time: '09:33', tag: '新', tagColor: 'bg-accent-500', title: '娱乐圈知名经纪人突然宣布辞职，旗下艺人集体沉默', views: '7.2万' },
  { time: '08:17', tag: '热', tagColor: 'bg-primary-400', title: '昨晚某音乐节现场设备故障，歌手清唱救场获全场掌声', views: '6.9万' },
  { time: '07:45', tag: '新', tagColor: 'bg-accent-500', title: '51吃瓜网今日吃瓜早报：三条重磅消息今晨集中曝光', views: '11.4万' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-flashlight-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          今日吃瓜更新
        </h2>
        <p className="text-sm text-foreground-500 mb-8">实时追踪51吃瓜网今日吃瓜最新动态，每分钟都在刷新</p>

        <div className="space-y-0">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-b-0 group cursor-pointer hover:bg-background-50/80 transition-colors duration-150 px-2 -mx-2 rounded-lg"
            >
              <span className="text-xs text-foreground-400 font-mono whitespace-nowrap mt-0.5">{item.time}</span>
              <span className={`${item.tagColor} text-background-50 text-[10px] font-bold px-1.5 py-0.5 rounded whitespace-nowrap mt-0.5`}>{item.tag}</span>
              <span className="text-sm text-foreground-800 leading-relaxed group-hover:text-primary-600 transition-colors duration-150 flex-1">{item.title}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5">{item.views}围观</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}